import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {setDeleteFile} from "features/model/slice/test/delete-file/deleteFileSlice";


export const deleteFile = createAsyncThunk(
    "lessons/deleteTestFile",
    async ({testId, filePath, questionId}: {
        testId: string | undefined;
        filePath: string;
        questionId: string | number
    }, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const {token} = JSON.parse(authToken);
            const response = await axios.delete(`/api/tests/file/${testId}`, {
                data: {
                    file: filePath,
                    questionId: questionId,
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },

            });
            thunkAPI.dispatch(setDeleteFile(response.data))
            return response.data;
        } catch (error) {
            console.error("An error occurred:", error);
            return thunkAPI.rejectWithValue("Error deleting file.");
        }
    }
);
